import { GzRmResourcesByOsWidgetWebComponent } from './component/GzRmResourcesByOsWidgetWebComponent';

export { GzRmResourcesByOsWidgetWebComponent };
